import {NgModule} from "@angular/core";
import {MatMenuModule} from "@angular/material/menu";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatBadgeModule} from "@angular/material/badge";
import {MatButtonModule} from "@angular/material/button";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDividerModule} from "@angular/material/divider";
import {MatListModule} from "@angular/material/list";
import {MatSliderModule} from "@angular/material/slider";
import {MatRadioModule} from "@angular/material/radio";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTableModule} from "@angular/material/table";
import {MatTabsModule} from "@angular/material/tabs";
import {MatStepperModule} from "@angular/material/stepper";
import {MatChipsModule} from "@angular/material/chips";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatSortModule} from "@angular/material/sort";
import {MatGridListModule} from "@angular/material/grid-list";
import {FlexLayoutModule, FlexModule} from "@angular/flex-layout";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatTreeModule} from "@angular/material/tree";
import {MatToolbarModule} from "@angular/material/toolbar";
import {ReactiveFormsModule} from "@angular/forms";
import {MatNativeDateModule, MatRippleModule} from "@angular/material/core";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {ScrollingModule} from "@angular/cdk/scrolling";
// import {AgmCoreModule} from "@agm/core";
// import {environment} from "../../../environments/environment";
import {MatGoogleMapsAutocompleteModule} from "@angular-material-extensions/google-maps-autocomplete";
import {CdkContextMenuTrigger, CdkMenu, CdkMenuItem, CdkMenuModule} from "@angular/cdk/menu";


const modules = [
  MatMenuModule,
  MatToolbarModule,
  MatCardModule,
  MatIconModule,
  MatSidenavModule,
  MatBadgeModule,
  MatButtonModule,
  MatExpansionModule,
  MatDividerModule,
  MatListModule,
  MatSliderModule,
  MatRadioModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatSnackBarModule,
  MatDialogModule,
  MatTableModule,
  MatTabsModule,
  MatStepperModule,
  MatChipsModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatDatepickerModule,
  MatSlideToggleModule,
  MatSortModule,
  MatGridListModule,
  FlexLayoutModule,
  MatTooltipModule,
  MatTreeModule,
  ReactiveFormsModule,
  MatRippleModule,
  MatNativeDateModule,
  MatButtonToggleModule,
  MatProgressSpinnerModule,
  DragDropModule,
  ClipboardModule,
  ScrollingModule,
  MatGoogleMapsAutocompleteModule,
  // AgmCoreModule,
  FlexModule,
  MatAutocompleteModule,
  CdkMenuModule,
  CdkContextMenuTrigger,
  CdkMenu,
  CdkMenuItem
]

@NgModule({
  declarations: [],
  imports: [
    ...modules,

  ],
  exports: [
    ...modules,
  ],
  providers: []
})
export class MaterialModule { }
